import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Calendar, Book, Users, Heart, HelpingHand as PrayingHands, Globe, ArrowRight, MapPin, Bell, BookOpen, Shield, BookOpenCheck, MessageSquare, HelpingHand, Compass, GraduationCap, LayoutDashboard } from 'lucide-react';
import { isAdmin } from '../lib/auth';
import { supabase } from '../lib/supabase';

export default function Home() {
  const navigate = useNavigate();
  const [isAdminUser, setIsAdminUser] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  React.useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    const adminStatus = await isAdmin();
    setIsAdminUser(adminStatus);
    
    // Verificar se o usuário está logado
    const { data: { session } } = await supabase.auth.getSession();
    setIsLoggedIn(!!session);
  }

  const menuItems = [
    {
      icon: Play,
      title: 'Ao Vivo',
      description: 'Assista nossos cultos ao vivo',
      path: '/live',
      color: 'bg-red-100 text-red-600',
    },
    {
      icon: MapPin,
      title: 'Onde Estamos',
      description: 'Localização e horários',
      path: '/location',
      color: 'bg-green-100 text-green-600',
    },
    {
      icon: Calendar,
      title: 'Eventos',
      description: 'Confira nossa agenda',
      path: '/events',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      icon: Book,
      title: 'Palavra',
      description: 'Mensagens e estudos bíblicos',
      path: '/word',
      color: 'bg-green-100 text-green-600',
    },
    {
      icon: BookOpen,
      title: 'Bíblia',
      description: 'Leia e estude a Palavra',
      path: '/bible',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      icon: GraduationCap,
      title: 'Cursos Bíblicos',
      description: 'Aprenda e cresça na fé',
      path: '/cursos',
      color: 'bg-indigo-100 text-indigo-600',
    },
    {
      icon: BookOpenCheck,
      title: 'Dicas Cristãs',
      description: 'Livros e filmes recomendados',
      path: '/christian-tips',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      icon: MessageSquare,
      title: 'Testemunhos',
      description: 'Histórias de transformação',
      path: '/testimonials',
      color: 'bg-green-100 text-green-600',
    },
    {
      icon: Heart,
      title: 'Conselheiro Espiritual',
      description: 'Versículos personalizados',
      path: '/spiritual-counselor',
      color: 'bg-pink-100 text-pink-600',
    },
    {
      icon: Compass,
      title: 'Orientação Espiritual',
      description: 'Pedidos de oração e dúvidas',
      path: '/spiritual-guidance',
      color: 'bg-amber-100 text-amber-600',
    },
    {
      icon: Users,
      title: 'Pequenos Grupos',
      description: 'Encontre seu grupo',
      path: '/small-groups',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      icon: PrayingHands,
      title: 'Pedidos de Oração',
      description: 'Compartilhe suas necessidades',
      path: '/prayer',
      color: 'bg-amber-100 text-amber-600',
    },
    {
      icon: Bell,
      title: 'Notificações',
      description: 'Mensagens importantes',
      path: '/notifications',
      color: 'bg-blue-100 text-blue-600',
    }
  ];

  // Adicionar item de dashboard para usuários logados
  if (isLoggedIn) {
    menuItems.unshift({
      icon: LayoutDashboard,
      title: 'Minha Jornada',
      description: 'Acompanhe sua jornada de fé',
      path: '/dashboard',
      color: 'bg-teal-100 text-teal-600',
    });
  }

  // Adicionar item de administração apenas para admins
  if (isAdminUser) {
    menuItems.push({
      icon: Shield,
      title: 'Administração',
      description: 'Gerenciar o sistema',
      path: '/admin',
      color: 'bg-brand-light text-brand-teal',
    });
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Menu Grid */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid gap-4 md:grid-cols-2">
          {menuItems.map((item) => (
            <button
              key={item.title}
              onClick={() => navigate(item.path)}
              className="bg-white p-6 rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-shadow text-left flex items-start gap-4"
            >
              <div className={`p-3 rounded-xl ${item.color}`}>
                <item.icon className="h-6 w-6" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h2>
                  <ArrowRight className="h-5 w-5 text-gray-400" />
                </div>
                <p className="text-gray-600 text-sm mt-1">
                  {item.description}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Versículo do Dia */}
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="bg-brand-light p-6 rounded-xl">
          <h2 className="text-lg font-semibold text-brand-teal mb-2">
            Versículo do Dia
          </h2>
          <p className="text-gray-700 italic">
            "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna."
          </p>
          <p className="text-gray-600 text-sm mt-2">
            João 3:16
          </p>
        </div>
      </div>
    </div>
  );
}